import { Toast } from 'antd-mobile';
import { readerImage } from '@/asset/js/utils';
import {
  annualRankingInfo,
  annualRankingList,
  annualRankingTaskList,
  annualRankingReceiveTask,
  annualRankingOpenRate,
  annualRankingExchangeInfo,
  annualRankingExchange,
  annualRankingGetTicket,
  annualRankingExchangeDetail,
  annualDrawInfo,
  annualDraw,
  getDrawHistory,
  annualFloatScreen,
  annualUnionList,
} from '@/services/activity';

export default {
  namespace: 'activityAnnualRanking',
  state: {
    endTime: 0,
    musicUrl: '',
    title: '',
    titleUrl: '',
    rules: '',
    childPageUrl: '',
    childBgColor: '',
    gifts: [],
    ranks: [],
    selfInfo: {},
    lastId: '',
    status: 0,
    drawEndTime: 0,
    drawStatus: 0,
    exchangeEndTime: 0,
    exchangeStatus: 0,
    exchangeTitleUrl: '',
    exchangeShopList: [],
    exchangeDetailList: [],
    exchangeIsMore: false,
    exchangeRules: '',
    exchangeTitle: '',
    unionSelfInfo: {},
    unionMasterName: '',
    unionName: '',
    unionMasterHeadAvatar: '',
    unionMasterId: '',
    unionScore: '',
    unionRanks: [],
    unionLastId: '',
    unionDailyRewards: [],
    unionTotalRewards: [],
    pageDetailNum: 1,
    pageDetailSize: 20,
    ticketNum: 0,
    dailyRewards: [], // 日榜奖励
    totalRewards: [], // 总榜奖励
    activityDates: [], // 日榜时间
    nowDate: '', // 当前时间
    taskList: [],
    awardList: [],
    countRank: [],
    luckyEndTime: 0,
    luckyStartTime: 0,
    remainNum: 0,
    luckyRules: '',
    luckyTitle: '',
    luckyTitleUrl: '',
    luckyStatus: 0,
    activeRoomId: '',
    recordList: [],
    pageNum: 1,
    pageSize: 20,
    isMore: false,
    global_status: 1,
    rankShowMode: 0,
    rankShowScore: 0,
    headAvatarClickable: 0,
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        endTime: payload.endTime || 0,
        musicUrl: payload.musicUrl,
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        rules: payload.rules,
        childPageUrl: payload.childPageUrl || '',
        gifts: payload.gifts || [],
        childBgColor: payload.childBgColor || '',
        status: payload.activityStatus || 0,
        drawEndTime: payload.drawEndTime || 0,
        drawStatus: payload.drawStatus || 0,
        exchangeEndTime: payload.exchangeEndTime || 0,
        exchangeStatus: payload.exchangeStatus || 0,
        receiveTaskInfos: payload.receiveTaskInfos || [],
        dailyRewards: payload.dailyRewards || [],
        totalRewards: payload.totalRewards || [],
        activityDates: payload.activityDates || [],
        nowDate: payload.nowDate || '',
        unionDailyRewards: payload.unionDailyRewards || [],
        unionTotalRewards: payload.unionTotalRewards || [],
        global_status: payload.mainInfoBindingMode || 1,
        rankShowMode: payload.rankShowMode || 0,
        rankShowScore: payload.rankShowScore || 0,
        headAvatarClickable: payload.headAvatarClickable || 0,
      };
    },
    updateExchangeInfo(state, { payload }) {
      return {
        ...state,
        exchangeEndTime: payload.exchangeEndTime || 0,
        exchangeStatus: payload.exchangeStatus || 0,
        exchangeTitleUrl: payload.titleUrl || '',
        exchangeTitle: payload.title || '',
        exchangeRules: payload.rules || '',
        exchangeShopList: payload.shopItemList || [],
      };
    },
    updateTicketInfo(state, { payload }) {
      return {
        ...state,
        ticketNum: payload.num || 0,
      };
    },
    updateList(state, { payload }) {
      let list = payload.force ? [] : [...state.ranks];
      let selfInfo = {};
      let lastId = '';
      if (payload.ranks && payload.ranks.length) {
        list = [...list, ...payload.ranks];
        lastId = payload.rankType == 3 ? payload.ranks[payload.ranks.length - 1].unionId : payload.ranks[payload.ranks.length - 1].userId;
      }
      if (payload.rankType == 3 && payload.selfInfo && payload.selfInfo.unionId) {
        selfInfo = payload.selfInfo;
      } else if (payload.selfInfo && payload.selfInfo.userId) {
        selfInfo = payload.selfInfo;
      }
      return {
        ...state,
        selfInfo: selfInfo,
        ranks: list,
        lastId: lastId,
      };
    },
    updateUnionList(state, { payload }) {
      let list = payload.force ? [] : [...state.unionRanks];
      let selfInfo = {};
      let lastId = '';
      if (payload.ranks && payload.ranks.length) {
        list = [...list, ...payload.ranks];
        lastId = payload.ranks[payload.ranks.length - 1].userId;
      }
      if (payload.selfInfo && payload.selfInfo.unionId) {
        selfInfo = payload.selfInfo;
      }
      return {
        ...state,
        unionSelfInfo: selfInfo,
        unionMasterName: payload.unionMasterName || '',
        unionName: payload.unionName || '',
        unionMasterHeadAvatar: payload.unionMasterHeadAvatar || '',
        unionScore: payload.unionScore || '',
        unionRanks: list,
        unionLastId: lastId,
        unionMasterId: payload.unionMasterId || '',
      };
    },
    updateDetailExchange(state, { payload }) {
      let list = payload.force ? [] : [...state.exchangeDetailList];
      let isMore = false;
      if (payload.list && payload.list.length) {
        list = [...list, ...payload.list];
        isMore = !!payload.list[payload.list.length - 1];
      }
      return {
        ...state,
        pageDetailNum: payload.pageNum || 1,
        exchangeDetailList: list,
        exchangeIsMore: isMore || false,
      };
    },
    updateTaskInfo(state, { payload }) {
      return {
        ...state,
        taskList: payload.data || [],
      };
    },
    updateDrawInfo(state, { payload }) {
      return {
        ...state,
        awardList: payload.awardList || [],
        countRank: payload.countRank || [],
        luckyEndTime: payload.endTime || 0,
        luckyStartTime: payload.startTime || 0,
        remainNum: payload.remainNum || 0,
        luckyRules: payload.rules || '',
        luckyTitle: payload.title || '',
        luckyTitleUrl: payload.titleUrl || '',
        luckyStatus: payload.status || 0,
        activeRoomId: payload.roomId || '',
      };
    },
    updateRecordList(state, { payload }) {
      let newList = payload.force ? [] : [...state.recordList];
      if (payload.records && payload.records.length) {
        newList = [...newList, ...payload.records];
      }
      return {
        ...state,
        recordList: newList,
        pageNum: payload.pageNum,
        isMore: newList.length < payload.total,
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(annualRankingInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return true;
    },
    *getExchangeInfo({ payload }, { call, put }) {
      const { error, data } = yield call(annualRankingExchangeInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateExchangeInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateExchangeInfo',
        payload: data,
      });
      return true;
    },
    *getTicketInfo({ payload }, { call, put }) {
      const { error, data } = yield call(annualRankingGetTicket, payload);
      if (error || !data) {
        yield put({
          type: 'updateTicketInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {};
      }
      yield put({
        type: 'updateTicketInfo',
        payload: data,
      });
      return data;
    },
    *getList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.activityAnnualRanking);
      const { error, data } = yield call(annualRankingList, { ...payload, lastId: payload.force ? '' : lastId, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateList',
        payload: { ...data, force: payload.force, rankType: payload.rankType || 1 },
      });
      return true;
    },
    *getUnionList({ payload }, { call, put, select }) {
      const { unionLastId } = yield select(state => state.activityAnnualRanking);
      const { error, data } = yield call(annualUnionList, { ...payload, lastId: payload.force ? '' : unionLastId, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateUnionList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateUnionList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *getExchangeDetail({ payload }, { call, put, select }) {
      const { pageDetailNum = 1, pageDetailSize = 20 } = yield select(state => state.activityAnnualRanking);
      const { error, data } = yield call(annualRankingExchangeDetail, { ...payload, pageNum: payload.force ? 1 : pageDetailNum, pageSize: pageDetailSize, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateDetailExchange',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateDetailExchange',
        payload: { list: data || [], pageNum: payload.force ? 2 : pageDetailNum + 1, force: payload.force },
      });
      return true;
    },
    *getTaskInfo({ payload }, { call, put }) {
      const { error, data } = yield call(annualRankingTaskList, payload);
      if (error || !data) {
        yield put({
          type: 'updateTaskInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateTaskInfo',
        payload: {
          data: data || [],
        },
      });
      return true;
    },
    *receiveDailyTask({ payload }, { call }) {
      const { error, code, data } = yield call(annualRankingReceiveTask, payload);
      if (error && code != 1) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
          code,
        };
      } else {
        return {
          data,
          success: true,
        };
      }
    },
    *openRate({ payload }, { call }) {
      const { error, code, data } = yield call(annualRankingOpenRate, payload);
      if (error && code != 1) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
          code,
        };
      } else {
        return {
          data,
          success: true,
        };
      }
    },
    *exchangeGift({ payload }, { call }) {
      const { error, code, data } = yield call(annualRankingExchange, payload);
      if (error && code != 1) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
          code,
        };
      } else {
        return {
          data,
          success: true,
        };
      }
    },
    *clearList({ payload }, { call, put }) {
      yield put({
        type: 'updateList',
        payload: { force: true },
      });
    },
    *clearUnionList({ payload }, { call, put }) {
      yield put({
        type: 'updateUnionList',
        payload: { force: true },
      });
    },
    *getDrawInfo({ payload }, { call, put }) {
      const { error, data } = yield call(annualDrawInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateDrawInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      if (data) {
        for (let i = 0; i < data.awardList.length; i++) {
          const { width, height } = yield readerImage(data.awardList[i].image);
          let w = 40;
          let h = 40;
          let t = 25;
          if (width > height) {
            h = (height / width) * w;
            t = (40 - h) / 2 + t;
          } else if (width < height) {
            w = (width / height) * h;
          } else {
            w = 40;
            h = 40;
          }
          data.awardList[i].w = w;
          data.awardList[i].h = h;
          data.awardList[i].t = t;
        }
        yield put({
          type: 'updateDrawInfo',
          payload: { ...data },
        });
      }
      return true;
    },
    *draw({ payload }, { call }) {
      const { error, data, code } = yield call(annualDraw, payload);
      if (error) {
        return {
          success: false,
          error,
          code,
        };
      }
      if (data) {
        return {
          data,
          success: true,
        };
      } else {
        return false;
      }
    },
    *getRecordListLoadMore({ payload }, { call, put, select }) {
      const { pageNum, pageSize } = yield select(state => state.activityAnnualRanking);
      const { error, data } = yield call(getDrawHistory, {
        ...payload,
        pageNum: payload.force ? 1 : pageNum,
        pageSize: pageSize,
        force: undefined,
      });
      if (error || !data) {
        yield put({
          type: 'updateRecordList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateRecordList',
        payload: { ...data, pageNum: payload.force ? 2 : pageNum + 1, force: payload.force },
      });
      return true;
    },
    *getFloatList({ payload }, { call }) {
      const { error, data } = yield call(annualFloatScreen, payload);
      if (error) {
        return {
          error,
          success: false,
        };
      }
      if (data) {
        return data.length ? data : [];
      } else {
        return false;
      }
    },
  },
};
